import { Actions, type CardActionsProps } from "./Actions";
import { Body, type CardBodyProps } from "./Body";
import { BodyHeader } from "./BodyHeader";
import BodyTitle from "./BodyTitle";
import { type CardFooterProps, Footer } from "./Footer";
import { type CardHeaderProps, Header } from "./Header";
import { type CardRootProps, Root } from "./Root";
import { type CardTitleProps, Title } from "./Title";

export const Card = {
  Root,
  Header,
  Title,
  Actions,
  Body,
  BodyHeader,
  BodyTitle,
  Footer,
};

export type { CardRootProps, CardHeaderProps, CardActionsProps, CardTitleProps, CardBodyProps, CardFooterProps };
